import React from 'react';
import { useState } from 'react';

import { Box } from '@rbilabs/universal-components';
import { useMinimalCartUi } from 'features/cart/hooks/use-minimal-cart-ui';
import { MenuReorderCard } from 'features/menu/components/menu-reorder-widget/menu-reorder-card';
import { MenuReorderDetailsDrawer } from 'features/menu/components/menu-reorder-widget/menu-reorder-details-drawer';
import { useLastOrderAvailableToReorder } from 'features/menu/components/menu-reorder-widget/use-last-order-available-to-reorder';
import { MinimalMenuReorderWidget } from 'features/menu/components/minimal-menu-reorder-widget/minimal-menu-reorder-widget';

import { CenteredRowContainer } from 'components/layout/centered-row-container';
import { useExposeMinimalCartExperiment } from 'experiments/use-enable-minimal-cart-experiment';
import { CustomEventNames } from 'state/amplitude';

const LegacyMenuReorderWidget = () => {
  const openDetailEventMessage = CustomEventNames.LAST_ORDER_DETAILS;
  const lastOrder = useLastOrderAvailableToReorder();
  const [isDetailsDrawerOpen, setIsDetailsDrawerOpen] = useState<boolean>(false);
  const toggleDetailsDrawer = () => setIsDetailsDrawerOpen(!isDetailsDrawerOpen);

  useExposeMinimalCartExperiment(Boolean(lastOrder));

  if (!lastOrder) {
    return null;
  }

  return (
    <CenteredRowContainer>
      {isDetailsDrawerOpen ? (
        <MenuReorderDetailsDrawer
          order={lastOrder}
          showDrawer={isDetailsDrawerOpen}
          toggleDetailsDrawer={toggleDetailsDrawer}
          openDetailEventMessage={openDetailEventMessage}
        />
      ) : (
        <Box padding="$4">
          <MenuReorderCard
            order={lastOrder}
            toggleDetailsDrawer={toggleDetailsDrawer}
            drawerIsOpen={isDetailsDrawerOpen}
          />
        </Box>
      )}
    </CenteredRowContainer>
  );
};

export const MenuReorderWidget = () => {
  const enableMinimalCartUi = useMinimalCartUi();

  return enableMinimalCartUi ? <MinimalMenuReorderWidget /> : <LegacyMenuReorderWidget />;
};
